import React from 'react';
import PropTypes from 'prop-types';

import DataTableHeading from './DataTableHeading';
import utils from './utils';

const DataTableHeader = (props) => {
    const {
        columns,
        onSortChange,
        isDraggable,
        stickyHeader,
    } = props;

    const renderDndCell = () => (
        isDraggable ?
            <th className="data-table__heading data-table__heading--dnd" />
            :
            null
    );

    const className = stickyHeader ? ' data-table__header-row' : '';

    const style = stickyHeader ? {
        background: '#fff',
        position: 'fixed',
        zIndex: 1,
        marginTop: '-114px',
        width: '68.4rem',
        marginLeft: '-59px',
    } : {};

    return (
        <thead className={`data-table__header${className}`} style={style}>
            <tr style={{ width: '100%' }}>
                {renderDndCell()}
                {
                    columns.map((column, index) => {
                        const colKey = utils.getColumnKey(column.accessor, index);

                        return (
                            <DataTableHeading
                                {...props}
                                column={column}
                                key={colKey}
                                onSortChange={onSortChange}
                            />
                        );
                    })
                }
            </tr>
        </thead >
    );
};

DataTableHeader.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
        accessor: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.func,
            PropTypes.string,
            PropTypes.bool,
        ]).isRequired,
        align: PropTypes.oneOf(['center', 'left', 'right']),
        className: PropTypes.string,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool,
        ]).isRequired,
    })).isRequired,
    onSortChange: PropTypes.func.isRequired,
    isDraggable: PropTypes.bool,
    stickyHeader: PropTypes.bool,
};

DataTableHeader.defaultProps = {
    isDraggable: false,
    stickyHeader: false,
};

export default DataTableHeader;
